import React from 'react';

import { useBoard, useDragAndDrop } from '../../hooks';
import NewStatusButton from './NewStatusButton';
import Skeleton from './Skeleton';
import StatusGroup from './StatusGroup';

const CONTAINER_STYLES = [
  'flex',
  'gap-4',
  'p-2',
  'h-full',
  'min-h-0',
  'overflow-x-auto',
  'overflow-y-hidden',
  '[scrollbar-width:none]',
  '[-ms-overflow-style:none]',
  '[-webkit-scrollbar]:hidden',
].join(' ');

const ColumnView = () => {
  const { isLoading, statuses } = useBoard();

  useDragAndDrop();

  if (isLoading) return <Skeleton />;

  return (
    <div className={CONTAINER_STYLES}>
      {statuses.map((status) => (
        <StatusGroup key={status.id} status={status} />
      ))}

      <NewStatusButton />
    </div>
  );
};

export default ColumnView;
